import { render, staticRenderFns } from "./trendDetail.vue?vue&type=template&id=09d8b20c&scoped=true&"
import script from "./trendDetail.vue?vue&type=script&lang=js&"
export * from "./trendDetail.vue?vue&type=script&lang=js&"
import style0 from "./trendDetail.vue?vue&type=style&index=0&id=09d8b20c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d8b20c",
  null
  
)

export default component.exports